// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__9gjfE","disabled":"Counter_disabled__COYKn","horizontal":"Counter_horizontal__Iy++J"};